import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=fbbe3108&scoped=true"
import script from "./UploadPicture.vue?vue&type=script&lang=js"
export * from "./UploadPicture.vue?vue&type=script&lang=js"
import style0 from "./UploadPicture.vue?vue&type=style&index=0&id=fbbe3108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbe3108",
  null
  
)

export default component.exports